<template>

  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="client_is_load" parent="client">
    <tab id="info" :name="translate('client.main_info.title')" :href="url+'/info'">
      <MainInfo :client_info="client_info" @update_client="get_client"/>
    </tab>

    <tab id="users" :name="translate('client.users.title')" :href="url+'/users'">
      <Users />
    </tab>

    <tab id="groups" :name="translate('client.groups.title')" :href="url+'/groups'">
      <Groups />
    </tab>

    <tab id="settings" :name="translate('client.settings.title')" :href="url+'/settings'">
      <Settings :client_info="client_info" @update_client="get_client"/>
    </tab>

    <tab id="role_manager" :name="translate('client.role_manager.title')" :href="url+'/role_manager'">
      <RoleManager :client_id="client_info.id"/>
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              Client: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/client_list'}">
              To Client list
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import MainInfo from "./Tabs/Info/Index.vue";
import Groups from "./Tabs/Groups/Index.vue";
import Users from "./Tabs/Users/Index.vue";
import Settings from "./Tabs/Settings/Index.vue";
import RoleManager from "./Tabs/RoleManager/Index.vue";
// import Contracts from "./Tabs/Contracts/SimTaskList.vue";


export default {
  name: 'Client',
  components: {
    RoleManager,
    Users,
    MainInfo,
    Groups,
    Settings,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      client_info: null,
    }
  },

  computed: {
    url () { return '/client/' + this.$route.params.client_id },
    cur_id () { return this.$route.params.client_id },
    load () { return !this.client_info?.id },
    client_is_load() { return this.client_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'client_section') {
        this.get_client()
      }
    }
  },

  activated(){
    this.get_client()
  },

  methods: {
    get_client () {
      this.$http.v1.getClientInfo(this.$route.params.client_id, (response) => {
        this.client_info = response.data
        this.$store.commit('updateSelectedClient', response.data)
      })
    }
  }
}

</script>
